import api from "@/services/api.ts";
import {Setting} from "@/types/Setting.ts";

const URL = '/settings';

// Get All Settings
export const getSettings = async (): Promise<Setting[]> => {
    const response = await api.get<Setting[]>(URL);
    return response.data;
};

export const fetchMaxNumberOfMentees = async (): Promise<number> => {
    const response = await api.get(`${URL}?key=max_number_of_mentees`);
    return response.data.value;
}

export const fetchLastDateToSubmitPreferences = async (): Promise<Date> => {
    const response = await api.get(`${URL}?key=last_date_to_submit_preferences`);
    return new Date(response.data.value);
}

export const fetchLastDateToSelectMentor = async (): Promise<Date> => {
    const response = await api.get(`${URL}?key=last_date_to_choose_mentor`);
    return new Date(response.data.value);
}

// Update Setting
export const updateSetting = async (id: number, setting: Setting): Promise<Setting> => {
    try {
        const response = await api.put(`${URL}/${id}`, setting);
        return response.data;
    } catch (error) {
        throw new Error('Failed to update Setting');
    }
}
